import { render, staticRenderFns } from "./AdminClient.vue?vue&type=template&id=f69615e0"
import script from "./AdminClient.vue?vue&type=script&lang=js"
export * from "./AdminClient.vue?vue&type=script&lang=js"
import style0 from "./AdminClient.vue?vue&type=style&index=0&id=f69615e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports